import React, {useEffect, useState} from 'react';
import './my-profile.scss';
import {Link, useNavigate} from 'react-router-dom';
import {ROUTES} from '../../constant/constant';
import {GetConsentsResponse, UpdateConsentsRequest} from '../../service/entity/entity-response';
import PersistenceService from '../../service/persistence-service';
import UserService from '../../service/user-service';
import Loader from '../../component/loader/Loader';

function MyProfile() {

  const [profile, setProfile] = useState({
    code: 0,
    description: 'OK',
    email: '',
    consents: []
  } as GetConsentsResponse);
  const navigateTo = useNavigate();

  useEffect(() => {
    UserService.getConsents().then((response: GetConsentsResponse) => {
      if (response.code === 0) {
        setProfile(response);
      } else {
        navigateTo(`${ROUTES.GENERIC_ERROR}/${response.description}`);
      }
    }).catch(error => {
      navigateTo(`${ROUTES.GENERIC_ERROR}/${error}`);
      console.error(error);
    });
  }, [])

  const onCheckboxChange = (key: string) => {
    const index = profile.consents.findIndex((item) => item.key === key);
    const item = profile.consents[index];
    item.value = !item.value;
  };

  const saveProfile = async () => {
    setProfile(profile);
    const request: UpdateConsentsRequest = { ...profile, ...{ phoneNumber: PersistenceService.getPhoneNumber() } };
    const response = await UserService.updateConsents(request);
    if (response.code === 0) {
      navigateTo(ROUTES.MP_UPDATED);
    } else {
      navigateTo(ROUTES.GENERIC_ERROR);
    }
  };

  return (
    <div className="MyProfile">
      {profile.email ? (
        <div className="page-container">
          <h3 className="page-title-success">Il tuo profilo</h3>
          <p>Da questa pagina puoi gestire i tuoi consensi o rimuovere il tuo account Wi-Fi</p>
          <div className="grey-container">
            <span>DATI REGISTRAZIONE</span>
            <div className="data-row">
              <div className="data-div">
                <span className='data-span'>Cellulare</span>
                <h3>{PersistenceService.getPhoneNumber()}</h3>
              </div>
              <div className="data-div">
                <span className='data-span'>Email</span>
                <h3>{profile.email}</h3>
              </div>
            </div>
          </div>

          <div className="tec">
            <label>* Campi obbligatori</label>
            {profile.consents
              .sort((a, b) => a.order - b.order)
              .map((item) => {
                return !item.editable ? (
                  <label className="checkbox-container" key={`label_${item.key}`}>
                    <span dangerouslySetInnerHTML={{ __html: item.description }} key={`s1_${item.key}`}></span>
                    <input
                      type="checkbox"
                      defaultChecked={item.value}
                      key={`input_${item.key}`}
                      onChange={() => onCheckboxChange(item.key)}
                      disabled={!item.editable} />
                    <span className={'checkmark ' + (!item.editable ? 'checkmark-disabled' : '')} key={`s2_${item.key}`}></span>
                  </label>
                ) : '';
              })}
            <label>Campi facoltativi </label>
            {profile.consents
              .sort((a, b) => a.order - b.order)
              .map((item) => {
                return item.editable ? (
                  <label className="checkbox-container" key={`label_${item.key}`}>
                    <span dangerouslySetInnerHTML={{ __html: item.description }} key={`s1_${item.key}`}></span>
                    <input
                      type="checkbox"
                      id={`${item.order}`}
                      onChange={() => onCheckboxChange(item.key)}
                      defaultChecked={item.value}
                      key={`input_${item.key}`}
                      disabled={!item.editable}
                    />
                    <span className="checkmark" key={`s2_${item.key}`}></span>
                  </label>
                ) : (
                  ''
                );
              })}
          </div>

          <div className="btn-div">
            <button className="confirm-btn" onClick={saveProfile}>
              Salva modifiche
            </button>
            <Link to={ROUTES.MP_DELETE} className="btn-link">
              <button className="link-btn">Elimina account</button>
            </Link>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default MyProfile;
